import { CREATE_INDUSTRY_TYPE, GET_INDUSTRY_TYPES, INDUSTRY_TYPE_REQUEST, DELETE_INDUSTRY_TYPE, UPDATE_INDUSTRY_TYPE, INDUSTRY_TYPE_REQUEST_FAILURE } from "../types";

const initialState = {
    industryTypes: [],
    loading: false,
    error: null,
  };

  const industryTypeReducer = (state = initialState, action) => {
    switch (action.type) {
      case INDUSTRY_TYPE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_INDUSTRY_TYPES: {
        return {
          ...state,
          industryTypes: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_INDUSTRY_TYPE:
        return {
          ...state,
          industryTypes: [action.payload, ...state.industryTypes],
          loading: false,
          error: null
        };
      case UPDATE_INDUSTRY_TYPE:
        const industryTypesData = state.industryTypes.slice(0);
        const uIndex = industryTypesData.findIndex((data) => data.id === action.payload.id);
        industryTypesData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          industryTypes: [ ...industryTypesData ],
          loading: false,
          error: null
        };
      case DELETE_INDUSTRY_TYPE:
        const industryTypes = state.industryTypes?.slice(0);
        const index = industryTypes.findIndex((data) => data.id === action.id);
        if (index > -1) {
            industryTypes.splice(index, 1);
        }
        return {
          ...state,
          industryTypes: [...industryTypes],
          loading: false,
          error: null
        }
      case INDUSTRY_TYPE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default industryTypeReducer;